module.exports = __webpack_public_path__ + "png/logo-mobile.png?62e7d83bfcf0bd3c8d9e70e7a6465e48";